import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useContext, useMemo } from 'react'
import { TextFieldInputNumber, parseFloatCheckValue } from '../Ticket/fnTickit';
import { ProviderExpensePlan } from './FundExpensesPlanForm';
import _ from "lodash";
import { debounce } from 'lodash';
import InputReactNumber from '../InputReactNumber';

const TableExpenseSectionProject = (props: { item: any; keyId: any; isVersion: any; }) => {


    const {
        arrMonth,
        setLstExpense,
        lstProject,
        setLstProject,
        calIndexOld,
        isVersion,
        lstProjectVersion,
        isView
    } = useContext(ProviderExpensePlan);

    const { item, keyId } = props;

    const lstProjectSection = useMemo(() => {
        let lstData = [];
        let listProjectTotal = isVersion ? lstProjectVersion : lstProject;
        if (listProjectTotal != null && listProjectTotal.length > 0) {
            lstData = listProjectTotal.filter((f: { nSectionId: any; }) => f.nSectionId === item.nSectionId);
        }
        return lstData
    }, [isVersion, item.nSectionId, lstProject, lstProjectVersion])


    const handleChangeValue = (eValue: any, indexMonth: any, indexRow: any, itemTable: any) => {
        handleChangeNoDebouce(eValue, indexMonth, indexRow, itemTable);
        //// Delay for set State
        // handleChangeInDebounced.cancel();
        // handleChangeInDebounced(eValue, indexMonth, indexRow, itemTable);
    }

    const handleChangeInDebounced = debounce((eValue: any, indexMonth: number, keyRow: { value: number; }, itemTable: { lstExpenseMonth: any; nQ1: any; nQ2: any; nQ3: any; nQ4: any; nTotal: any; }) => {
        keyRow.value = parseFloatCheckValue(eValue);
        if ([0, 1, 2].includes(indexMonth)) {
            // Q1
            let sumQ1 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ1 = sumQ1;
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            // Q2
            let sumQ2 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ2 = sumQ2;
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            // Q3
            let sumQ3 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ3 = sumQ3;
        }
        else {
            // Q4
            let sumQ4 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ4 = sumQ4;
        }
        itemTable.nTotal = itemTable.nQ1 + itemTable.nQ2 + itemTable.nQ3 + itemTable.nQ4;

        setLstProject((value: any) => [...value])
        setLstExpense((value: any) => [...value])
    }, 500);

    const handleChangeNoDebouce = (eValue: any, indexMonth: number, keyRow: { value: number; }, itemTable: { lstExpenseMonth: any; nQ1: any; nQ2: any; nQ3: any; nQ4: any; nTotal: any; }) => {
        keyRow.value = parseFloatCheckValue(eValue);
        if ([0, 1, 2].includes(indexMonth)) {
            // Q1
            let sumQ1 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [1, 2, 3].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ1 = sumQ1;
        }
        else if ([3, 4, 5].includes(indexMonth)) {
            // Q2
            let sumQ2 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [4, 5, 6].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ2 = sumQ2;
        }
        else if ([6, 7, 8].includes(indexMonth)) {
            // Q3
            let sumQ3 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [7, 8, 9].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ3 = sumQ3;
        }
        else {
            // Q4
            let sumQ4 = _.sumBy(itemTable.lstExpenseMonth, function (o: { nOrder: number; value: any; }) { return [10, 11, 12].includes(o.nOrder) ? parseFloatCheckValue(o.value) : 0; });
            itemTable.nQ4 = sumQ4;
        }
        itemTable.nTotal = itemTable.nQ1 + itemTable.nQ2 + itemTable.nQ3 + itemTable.nQ4;

        onSetListDedounce.cancel();
        onSetListDedounce();
    }

    const onSetListDedounce = debounce(() => {
        setLstProject((value: any) => [...value])
        setLstExpense((value: any) => [...value])
    }, 500);

    return (
        <TableContainer id='table-pinned' sx={{ maxHeight: "70vh" }} component={Paper}>
            <Table stickyHeader sx={{ minWidth: 1400 }}>
                <TableHead>
                    <TableRow>
                        <TableCell className="sticky-cell pad-0 head-color" component="th" padding='none' style={{ minWidth: '360px', width: '360px' }}>
                            <TableCell className='sticky-header cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                            <TableCell className='sticky-header cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '300px', width: '300px' }}>รายการ</TableCell>
                        </TableCell>
                        {
                            arrMonth.map((month: string, indexM: number) => {
                                let isFillColor = [3, 7, 11, 15].includes(indexM);
                                return (
                                    <TableCell
                                        key={month}
                                        component="th"
                                        padding='none'
                                        className={isFillColor ? '' : "head-color"}
                                        sx={{
                                            minWidth: '150px',
                                            width: '150px',
                                            backgroundColor: isFillColor ? '#70b603 !important' : "head-color"
                                        }}
                                    >
                                        {month}
                                    </TableCell>
                                )
                            })
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        lstProjectSection != null && lstProjectSection.length > 0 ?
                            <>
                                {
                                    lstProjectSection.map((itemTable, indexShow) => {
                                        let keyCellTable = keyId + "Id_" + item.nSectionId + "_Prj" + itemTable.nProjectID;
                                        return (
                                            <TableRow key={keyCellTable}>
                                                <TableCell className="sticky-cell pad-0 body-z2" padding='none' style={{ minWidth: '360px', width: '360px', backgroundColor: "#ffffff" }}>
                                                    <TableCell className='cell-in-sticky border-l' padding='none' align='center' style={{ minWidth: '60px', width: '60px' }}>{indexShow + 1}</TableCell>
                                                    <TableCell className='cell-in-sticky border-l' padding='none' align='left' style={{ minWidth: '300px', width: '300px' }}>{itemTable.sProjectName}</TableCell>
                                                </TableCell>
                                                {
                                                    itemTable.lstExpenseMonth.map((keyRow: { nOrder: string; value: string | number; }, indexMonth: number) => {
                                                        let keyCellInput = keyCellTable + "_Month" + keyRow.nOrder;
                                                        return (
                                                            <>
                                                                <TableCell
                                                                    key={keyCellInput}
                                                                    padding='none'
                                                                >
                                                                    {
                                                                        isVersion ?
                                                                            <TextFieldInputNumber value={keyRow.value} digit={2} />
                                                                            :
                                                                            <InputReactNumber //</>InputNumberItem //InputNumberIncomeExpense
                                                                                id={keyCellInput}
                                                                                name={keyCellInput}
                                                                                defaultValue={keyRow.value}
                                                                                required={false}
                                                                                disabled={isView || isVersion}
                                                                                IsCanMinus={false}
                                                                                IsShowMessageError={false}
                                                                                maxInteger={20}
                                                                                onChange={(eValue) => handleChangeValue(eValue, indexMonth, keyRow, itemTable)}
                                                                            />
                                                                    }
                                                                </TableCell>
                                                                {
                                                                    [2, 5, 8, 11].includes(indexMonth) ?
                                                                        <TableCell
                                                                            key={keyCellInput}
                                                                            padding='none'
                                                                        >
                                                                            <TextFieldInputNumber value={itemTable["nQ" + calIndexOld(indexMonth)]} digit={2} />
                                                                        </TableCell>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    [11].includes(indexMonth) ?
                                                                        <TableCell
                                                                            padding='none'
                                                                        >
                                                                            <TextFieldInputNumber value={itemTable.nTotal} digit={2} />
                                                                        </TableCell>
                                                                        :
                                                                        null
                                                                }
                                                            </>
                                                        )
                                                    })
                                                }
                                            </TableRow>
                                        )
                                    })
                                }
                            </>
                            :
                            <TableRow key={"r-no-data"}>
                                <TableCell align="center" colSpan={19}>
                                    ไม่พบข้อมูล
                                </TableCell>
                            </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default TableExpenseSectionProject